import { AxiosRequest } from "../../../Url";
import { ParamSetOption } from "../../Tools/ProjectX";
import { PostHandleTable } from "../../Tools/Requests";
import { defaultFieldInfo, getModalSectionID, getRightsData } from "../../Tools/Tools";
import { getParamColumnsOptions, parseColumns } from "../GridTools/parseColumnTools";

export async function booksGrid(grid, source, props, data) {
  let json = await PostHandleTable(props.Module, props.ObjType, undefined, props.SectionID);
  source.onHandleRequest = handleRequest(props);

  await source.open();

  if (json) {
    source.rights = getRightsData(json.Rights);

    if (json.ReadOnly === "1") grid.OnlyViewMode = true;

    let columns = {
      title: [
        {
          fieldName: "ID",
          title: "Ключ",
          width: 80,
          level: 0,
          hide: true,
          hideInGrid: true,
          hideInCard: true,
          options: getParamColumnsOptions(ParamSetOption.Hidden),
          fieldInfo: { ...defaultFieldInfo },
        },
      ],
    };

    grid.setColumns(parseColumns(json, { inputColumns: columns }));
  } else grid.defaultColumns = true;
  if (!props.ObjRef) await source.refresh();
  await grid.setSource(source);
  if (props.ObjRef) await grid.refreshSource(props.ObjRef);
  await grid.updateGridSize();
}

function handleRequest(props) {
  return function onHandleRequest(request) {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", props.ObjType)
      .set("SectionID", props.SectionID ? props.SectionID : getModalSectionID());
    return AxiosRequest(true, params, request);
  };
}
